import { registerPlugin } from '@capacitor/core';
const Print = registerPlugin('Print', {
    web: () => import('./web').then(m => new m.PrintWeb()),
});
export * from './definitions';
export { Print };
//# sourceMappingURL=index.js.map